import styled from "styled-components";

export const StyledContainer = styled("div")<{
  border?: boolean;
}>`
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 60px;
  overflow: visible;
  box-sizing: border-box;

  @media (max-width: 890px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;
